import React, { useEffect } from "react";
import styled from "styled-components";
import { useNavigate, NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setUserLogin, setSignOut } from "../features/user/UserSlice";
import { signInWithPopup, GoogleAuthProvider, signOut } from "firebase/auth";
import { auth, provider } from "../firebase-config";
import {
  selectUserName,
  selectEmail,
  selectPhoto,
} from "../features/user/UserSlice";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userName = useSelector(selectUserName);
  // const userEmail = useSelector(selectEmail);
  const userPhoto = useSelector(selectPhoto);

  useEffect(() => {
    auth.onAuthStateChanged(async (user) => {
      if (user) {
        const userData = {
          name: user.displayName,
          email: user.email,
          photo: user.photoURL,
        };
        dispatch(setUserLogin(userData));
        navigate("/");
      }
    });
  }, []);

  const googleAuth = () => {
    signInWithPopup(auth, provider)
      .then((result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        // The signed-in user info.
        const user = result.user;
        const userData = {
          name: user.displayName,
          email: user.email,
          photo: user.photoURL,
        };
        dispatch(setUserLogin(userData));

        // ...
      })
      .catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const email = error.customData.email;
        // The AuthCredential type that was used.
        const credential = GoogleAuthProvider.credentialFromError(error);
        // ...
      });
  };

  const signoutfunc = () => {
    signOut(auth)
      .then(() => {
        dispatch(setSignOut());
        navigate("/");
      })
      .catch((error) => {
        // An error happened.
      });
  };

  return (
    <Container>
      <Logo>
        <NavLink to="/">Todo Keep</NavLink>
      </Logo>
      <Nav>
        {!userName ? (
          <>
            <p
              onClick={googleAuth}
              style={{
                cursor: "pointer",
              }}
            >
              Login
            </p>
          </>
        ) : (
          <>
            <div>
              <NavLink to="/create" className="anchor">
                Create
              </NavLink>
              <span
                onClick={signoutfunc}
                className="anchor"
                style={{ cursor: "pointer" }}
              >
                Logout
              </span>
            </div>
            <Profile src={`${userPhoto}`}></Profile>
          </>
        )}
      </Nav>
    </Container>
  );
};

export default Header;

const Container = styled.div`
  background-color: yellow;
  padding: 20px 40px;
  box-shadow: 3px 3px 5px 1px rgb(228, 221, 221);
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Logo = styled.h3`
  & a {
    text-decoration: none;
    letter-spacing: 1.2px;
    color: black;
  }
`;
const Nav = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
  max-width: 60%;
  align-items: center;
  & .anchor {
    text-decoration: none;
    margin: 0px 10px;
    font-size: 15px;
    letter-spacing: 1.5px;
    color: black;
    position: relative;
    &::before {
      content: "";
      height: 2px;
      width: auto;
      background-color: black;
      left: 0px;
      right: 0px;
      bottom: -6px;
      position: absolute;
      opacity: 0;
      visibility: hidden;
      transform-origin: left center;
      transition: all 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      transform: scaleX(0);
    }
    &:hover::before {
      opacity: 1;
      transform: scaleX(100%);
      visibility: visible;
    }
  }
`;

const Profile = styled.img`
  height: 40px;
  border-radius: 100px;
  cursor: pointer;
`;
